export default {
  'app.title': 'RustDesk Console',
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all blocks',
  'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',
  'Controlled Device': 'Controlled Device',
  'Controlling Side': 'Controlling Side',
  'Controlling User': 'Controlling User',
  'controller_user_search_tip': 'Requires controlled client version >= 1.4.9.',
  'Authentication Method': 'Authentication Method',
  'Authentication': 'Authentication',
  'authentication_column_tip': 'Format: Primary Auth + 2FA. Requires controlled client version >= 1.4.9.',
  'Primary Auth': 'Primary Auth',
  'Auth Method': 'Auth Method',
  '2FA': '2FA',
  '2FA Code': '2FA Code',
  'Click Confirmation': 'Click Confirmation',
  'One-time Password': 'One-time Password',
  'Permanent Password': 'Permanent Password',
  'Switch Sides': 'Switch Sides',
  'Trusted Device': 'Trusted Device',
  'pages.AuditList.FileAuditList.pathTip': 'Path on Controlled Device',

  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',

  'component.globalHeader.search': 'Search',
  'component.globalHeader.search.example1': 'Search example 1',
  'component.globalHeader.search.example2': 'Search example 2',
  'component.globalHeader.search.example3': 'Search example 3',
  'component.globalHeader.help': 'Help',
  'component.globalHeader.notification': 'Notification',
  'component.globalHeader.notification.empty': 'You have viewed all notifications.',
  'component.globalHeader.message': 'Message',
  'component.globalHeader.message.empty': 'You have viewed all messages.',
  'component.globalHeader.event': 'Event',
  'component.globalHeader.event.empty': 'You have viewed all events.',
  'component.noticeIcon.clear': 'Clear',
  'component.noticeIcon.cleared': 'Cleared',
  'component.noticeIcon.empty': 'No notifications',
  'component.noticeIcon.view-more': 'View more',

  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.audit-list': 'Logs',
  'menu.list.audit-list.Alarm': 'Alarm',
  'menu.list.audit-list.Connection': 'Connection',
  'menu.list.audit-list.File': 'File',
  'menu.list.audit-list.Console': 'Console',
  'menu.Settings': 'Settings',
  'menu.Settings.Key': 'Key',
  'menu.Settings.License': 'License',
  'menu.Settings.Relay': 'Relay',
  'menu.Settings.Others': 'Others',
  'menu.Settings.Tokens': 'Tokens',
  'menu.list.device-list': 'Devices',
  'menu.list.user-list': 'Users',
  'menu.list.group-list': 'Groups',
  'menu.list.group-list.user': 'User Groups',
  'menu.list.group-list.device': 'Device Groups',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.list.role-list': 'Roles',
  'menu.list.role-list.admin': 'Admin Roles',
  'menu.list.role-list.control': 'Control Roles',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',

  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username or password',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: ant.design',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.Welcome.Concurrent Connections': 'Concurrent Connections',
  'pages.Welcome.Config': 'Config',
  'pages.Welcome.Windows EXE': 'Windows EXE',
  'pages.Welcome.Mobile QR Code': 'Mobile QR Code',
  'pages.Settings.OIDC.emptyPrompt': 'There is no third-party auth provider, please add one to use this feature.',
  'pages.Settings.OIDC.confirm-delete-title': 'Confirm Delete',
  'pages.Settings.OIDC.confirm-delete-content': 'The related third-party auth users will no longer be able to log in. You can delete these users in the user management.',
  'pages.Settings.OIDC.Use Avatar': 'Use Avatar',
  'pages.Settings.OIDC.use_avatar_tip': 'Sync the avatar when creating a new user.',
  'pages.Settings.OIDC.oidc_map_groups_tooltip': 'When Map Groups is enabled, users will be added to the corresponding user group upon their initial login. Subsequent logins will not update their user group. If a user belongs to multiple groups, they will only be added to one of them.',
  'pages.Settings.Others.idp_allow_local_password_login': 'Allow IdP (OIDC) users to log in with local password',
  'pages.Settings.Others.Session expiration time': 'Session expiration time',
  'pages.Settings.Others.Session expiration time tip': 'Changing this does not immediately shorten or extend sessions that are already signed in. It applies to future sign-ins; existing sessions keep their current expiration schedule.',
  'pages.Settings.Others.Session expiration mode': 'Session expiration mode',
  'pages.Settings.Others.Since recent activity': 'Since recent activity',
  'pages.Settings.Others.Since login': 'Since login',
  'pages.Settings.Others.Require deployment for new devices': 'Require deployment for new devices',
  'pages.Settings.Others.deployment_required_tip': 'When enabled, new devices must run `rustdesk --deploy --token <api_token>` to register on this server.',
  'pages.Settings.Others.access_require_login_license_tip': 'Always required for license with limited concurrent connections',
  'pages.Settings.Strategy.whitelist_sep': 'Separated by comma, semicolon, spaces or new line.',
  'pages.Settings.Strategy.whitelist_tip': 'Only whitelisted IP can access me.',
  'pages.Settings.Strategy.deny_lan_discovery_desc_tip': 'The device will not be discovered by other devices in the same LAN.',
  'pages.Settings.Strategy.enable_direct_ip_access_desc_tip': 'Allow direct IP connection to the device.',
  'pages.CustomClient.Package format': 'Package format',
  'pages.CustomClient.Package name': 'Package name',
  'pages.CustomClient.Bundle identifier': 'Bundle identifier',
  'pages.CustomClient.Server': 'Server',
  'pages.CustomClient.CPU Architecture': 'CPU Architecture',
  'pages.CustomClient.Distribution': 'Distribution',
  'pages.CustomClient.Disable auto padding of application icon': 'Disable auto padding of application icon',
  'pages.CustomClient.bidirectional_desc_tip': 'A client from which you can create connections to another device and receive incoming connection requests to your device.',
  'pages.CustomClient.incoming_desc_tip': 'A client that can only receive a connection from another device.',
  'pages.CustomClient.outgoing_desc_tip': 'A client from which you can only create an outgoing connection.',
  'pages.CustomClient.disable_installation_desc_tip': 'Disallow users to install the custom client (Windows-only).',
  'pages.CustomClient.disable_settings_desc_tip': 'Disable user\'s access to the custom client\'s settings.',
  'pages.CustomClient.disable_ab_desc_tip': 'Disable the Address Book feature in the custom client.',
  'pages.CustomClient.disable_tcp_desc_tip': 'Avoid the Windows Firewall dialog when RustDesk is started, and this leads to always relay connection, no P2P connection attempt any more.',
  'pages.CustomClient.disable_account_desc_tip': 'Remove the possibility for the user to log in to their account in the RustDesk client.',
  'pages.CustomClient.app_icon_desc_tip': 'Upload a square PNG image with a minimum size of 512x512 pixels for the desired icon for your custom client.',
  'pages.CustomClient.app_name_desc_tip': 'Specify a unique name, displayed in the start menu, control panel, etc. for installed RustDesk clients (Windows-only)',
  'pages.CustomClient.logo_desc_tip': 'Upload a PNG image that is shown at the top of the custom client’s Main Window. The size is scaled automatically. We recommend using a PNG with 200x40 pixels.',
  'pages.CustomClient.Light Logo': 'Light Logo',
  'pages.CustomClient.Dark Logo': 'Dark Logo',
  'pages.CustomClient.light_logo_desc_tip': 'Upload a PNG logo for light theme. The size is scaled automatically. We recommend using a PNG with 200x40 pixels.',
  'pages.CustomClient.dark_logo_desc_tip': 'Upload a PNG logo for dark theme. The size is scaled automatically. We recommend using a PNG with 200x40 pixels.',
  'pages.CustomClient.override_settings_desc_tip': 'Override settings without the possibility to change it back within RustDesk, separated by newline.',
  'pages.CustomClient.default_settings_desc_tip': 'Change the default settings that RustDesk is using by default, separated by newline.',
  'pages.CustomClient.Preset password is set.': 'Preset password is set.',
  'pages.CustomClient.Change password': 'Change password',
  'pages.CustomClient.Keep current password': 'Keep current password',
  'pages.welcome.advancedComponent': 'Advanced Component',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.advancedLayout': 'Advanced Layout',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',

  'app.pwa.offline': 'You are offline now',
  'app.pwa.serviceworker.updated': 'New content is available',
  'app.pwa.serviceworker.updated.hint': 'Please press the "Refresh" button to reload current page',
  'app.pwa.serviceworker.updated.ok': 'Refresh',

  'app.setting.pagestyle': 'Page style setting',
  'app.setting.pagestyle.dark': 'Dark style',
  'app.setting.pagestyle.light': 'Light style',
  'app.setting.content-width': 'Content Width',
  'app.setting.content-width.fixed': 'Fixed',
  'app.setting.content-width.fluid': 'Fluid',
  'app.setting.themecolor': 'Theme Color',
  'app.setting.themecolor.dust': 'Dust Red',
  'app.setting.themecolor.volcano': 'Volcano',
  'app.setting.themecolor.sunset': 'Sunset Orange',
  'app.setting.themecolor.cyan': 'Cyan',
  'app.setting.themecolor.green': 'Polar Green',
  'app.setting.themecolor.daybreak': 'Daybreak Blue (default)',
  'app.setting.themecolor.geekblue': 'Geek Blue',
  'app.setting.themecolor.purple': 'Golden Purple',
  'app.setting.navigationmode': 'Navigation Mode',
  'app.setting.sidemenu': 'Side Menu Layout',
  'app.setting.topmenu': 'Top Menu Layout',
  'app.setting.fixedheader': 'Fixed Header',
  'app.setting.fixedsidebar': 'Fixed Sidebar',
  'app.setting.fixedsidebar.hint': 'Works on Side Menu Layout',
  'app.setting.hideheader': 'Hidden Header when scrolling',
  'app.setting.hideheader.hint': 'Works when Hidden Header is enabled',
  'app.setting.othersettings': 'Other Settings',
  'app.setting.weakmode': 'Weak Mode',
  'app.setting.copy': 'Copy Setting',
  'app.setting.copyinfo': 'copy success, please replace defaultSettings in src/models/setting.js',
  'app.setting.production.hint':
    'Setting panel shows in development environment only, please manually modify',

  'app.settings.menuMap.basic': 'Basic Settings',
  'app.settings.menuMap.security': 'Security Settings',
  'app.settings.menuMap.binding': 'Account Binding',
  'app.settings.menuMap.notification': 'New Message Notification',
  'app.settings.basic.avatar': 'Avatar',
  'app.settings.basic.change-avatar': 'Change avatar',
  'app.settings.basic.email': 'Email',
  'app.settings.basic.email-message': 'Please input your email!',
  'app.settings.basic.nickname': 'Nickname',
  'app.settings.basic.nickname-message': 'Please input your Nickname!',
  'app.settings.basic.profile': 'Personal profile',
  'app.settings.basic.profile-message': 'Please input your personal profile!',
  'app.settings.basic.profile-placeholder': 'Brief introduction to yourself',
  'app.settings.basic.country': 'Country/Region',
  'app.settings.basic.country-message': 'Please input your country!',
  'app.settings.basic.geographic': 'Province or city',
  'app.settings.basic.geographic-message': 'Please input your geographic info!',
  'app.settings.basic.address': 'Street Address',
  'app.settings.basic.address-message': 'Please input your address!',
  'app.settings.basic.phone': 'Phone Number',
  'app.settings.basic.phone-message': 'Please input your phone!',
  'app.settings.basic.update': 'Update Information',
  'app.settings.security.strong': 'Strong',
  'app.settings.security.medium': 'Medium',
  'app.settings.security.weak': 'Weak',
  'app.settings.security.password': 'Account Password',
  'app.settings.security.password-description': 'Current password strength',
  'app.settings.security.phone': 'Security Phone',
  'app.settings.security.phone-description': 'Bound phone',
  'app.settings.security.question': 'Security Question',
  'app.settings.security.question-description':
    'The security question is not set, and the security policy can effectively protect the account security',
  'app.settings.security.email': 'Backup Email',
  'app.settings.security.email-description': 'Bound Email',
  'app.settings.security.mfa': 'MFA Device',
  'app.settings.security.mfa-description':
    'Unbound MFA device, after binding, can be confirmed twice',
  'app.settings.security.modify': 'Modify',
  'app.settings.security.set': 'Set',
  'app.settings.security.bind': 'Bind',
  'app.settings.binding.taobao': 'Binding Taobao',
  'app.settings.binding.taobao-description': 'Currently unbound Taobao account',
  'app.settings.binding.alipay': 'Binding Alipay',
  'app.settings.binding.alipay-description': 'Currently unbound Alipay account',
  'app.settings.binding.dingding': 'Binding DingTalk',
  'app.settings.binding.dingding-description': 'Currently unbound DingTalk account',
  'app.settings.binding.bind': 'Bind',
  'app.settings.notification.password': 'Account Password',
  'app.settings.notification.password-description':
    'Messages from other users will be notified in the form of a station letter',
  'app.settings.notification.messages': 'System Messages',
  'app.settings.notification.messages-description':
    'System messages will be notified in the form of a station letter',
  'app.settings.notification.todo': 'To-do Notification',
  'app.settings.notification.todo-description':
    'The to-do list will be notified in the form of a letter from the station',
  'app.settings.open': 'Open',
  'app.settings.close': 'Close',
  'transfer_address_book': 'Transfer address book',
  'transfer_address_book_confirm': 'Are you sure you want to transfer this address book?',
  'add_devices': 'Add devices',
  'add_users': 'Add users',
  'move_to': 'Move to',
  'audit_retention_days': 'Log Retention (Days)',
  'audit_retention_days_tip': 'Enter 0 to keep all logs indefinitely. Enter a number greater than 0 to automatically delete logs older than the specified number of days. Cleanup runs once per hour.',
  'days': 'days',
  'hours': 'hours',
  'set_password': 'Set password',
  'disable_read_accessible': 'Disable retrieving accessible devices',
  'disable_read_accessible_tip': 'When toggled on, the RustDesk client will not be able to retrieve accessible devices.',
  'default_shared_password': 'Default Shared Password',
  'default_shared_password_tip': 'Address book level shared password: if devices in this address book have no shared password set, this password will be used as the shared password.',
  'used_user': 'Licensed users (Current/Maximum)',
  'used_device': 'Licensed devices (Current/Maximum)',
  'last_online_sort_tip': 'Online sorting is only available when the total number of devices after filtering is ≤ 2000.',
  'last_online': 'Last Online Time',
  'batch_delete_device_tooltip': 'Only disabled and offline devices can be batch deleted. The ID in the confirmation dialog is the last selected device\'s ID.',
  'batch_delete_device_tooltip_deployment': 'Only disabled devices can be batch deleted (deployment mode allows removing online devices). The ID in the confirmation dialog is the last selected device\'s ID.',
  'More': 'More',
  'login_verification': 'Login Verification',
  'reset_2fa': 'Reset 2FA Configuration',
  'disable_email_login_verification': 'Disable Email Login Verification',
  'reset_2fa_confirm': 'Reset 2FA for the selected user(s)?',
  'disable_email_login_verification_confirm': 'Disable email login verification for the selected user(s)?',
  'login_verification_column_tip': 'If both 2FA and email verification are enabled, only 2FA will be used.',
  'reset_2fa_tip': 'A notification will be sent to the user\'s email (if configured). After the reset: if the user is 2FA-enforced, they must set up 2FA again on their next login; if not enforced, 2FA verification will no longer be required.',
  'disable_email_login_verification_tip': 'A notification will be sent to the user\'s email (if configured). After disabling, email verification will no longer be required on the next login.',
  'disable_in_account_setting_tip': 'Please disable your own login verification in the account settings.',
  'enable_2fa_enforcement': 'Enable 2FA Enforcement',
  'disable_2fa_enforcement': 'Disable 2FA Enforcement',
  'enable_2fa_enforcement_confirm': 'Are you sure you want to enforce 2FA login for users?',
  'disable_2fa_enforcement_confirm': 'Are you sure you want to disable 2FA enforcement?',
  '2fa_enforcement_enable_tip': 'A notification will be sent to the user\'s email (if configured). After enforcement, users will be required to set up 2FA on their next login and won’t be able to sign in until setup is complete.',
  '2fa_enforcement_disable_tip': 'A notification will be sent to the user\'s email (if configured). After disabling enforcement, users can still use 2FA, but it will no longer be mandatory.',
  'enforce_2fa_alert': 'Your administrator requires you to set up Two-Factor Authentication before continuing.',
  'backup_codes_desc': 'If you lose access to your two-factor authentication method, you can use one of your backup codes instead. Please store them securely.',
  'setup_2fa_success_alert': '2FA setup successful. Please download your backup codes and return to the login page.',
  '2fa_activation_status': '2FA Activation Status',
  '2fa_enforcement_status': '2FA Enforcement Status',
  '2fa_enforced_and_active': '2FA enforced and active',
  '2fa_enforced_but_pending': '2FA enforced but pending configuration by the user',
  '2fa_not_enforced_but_active': '2FA not enforced but active',
  'force_logout': 'Force Logout',
  'force_logout_tip': 'This will log out the selected user(s) from all devices.',
  'force_logout_current_session_tip': 'The current session will not be logged out.',
  'new_user_enforce_tfa': 'Enforce 2FA for new users',
  'new_user_enforce_tfa_tip': 'When enabled, new users must set up 2FA upon their first login.',
  'confirm_disable_2fa_title': 'Confirm Disable 2FA',
  'confirm_disable_2fa_tip': 'Your account requires two-factor authentication (2FA). If you disable it, you\'ll be prompted to set up 2FA again the next time you log in. Would you like to continue?',
  'reset_password': 'Reset Password',
  'assign_devices': 'Assign Devices',
  'email_login_verification_enabled': 'Email login verification is enabled',
  'user_status': 'User Status',
  'user_status_active': 'User is active.',
  'user_status_disabled': 'User is disabled.',
  'user_status_pending': 'Invitation sent. Waiting for user to accept.',
  'resend_invitation': 'User has not accepted the invitation. You can resend it.',
  'email_login_verification_status': 'Email Login Verification Status',
  'set_tags': 'Set tags',
  'set_note': 'Set note',
  'remove_all_tags': 'Remove all tags',
  'no_tags_available': 'No tags available',
  'remove_note': 'Remove note',
  'set_to_selected_tags': 'Set to selected tags',
  'add_selected_tags': 'Add selected tags',
  'remove_selected_tags': 'Remove selected tags',
  'clear_all_tags': 'Clear all tags',
  'Operation': 'Operation',
  'Tags': 'Tags',
  'Group Scoped': 'Group Scoped',
  'Scope': 'Scope',
  'user_group_permission': 'User Group Permissions',
  'device_group_permission': 'Device Group Permissions',
  'permission_column_header_tooltip': 'Any Edit permission includes View permission.',
  'user_column_header_tooltip': 'Non-admin users cannot operate on administrator accounts',
  'create_role': 'Create Role',
  'delete_role': 'Delete Role',
  'update_role': 'Update Role',
  'create_admin_role': 'Create Admin Role',
  'delete_admin_role': 'Delete Admin Role',
  'update_admin_role': 'Update Admin Role',
  'add_users_to_admin_role': 'Add Users to Admin Role',
  'remove_users_from_admin_role': 'Remove Users from Admin Role',
  'admin_not_restricted_by_roles': 'Administrators are not restricted by admin roles, although admin roles can be assigned to administrators.',
  // User permissions - Global type
  'view_users_permission_description_global': 'Read list information of all users.',
  'user_create_permission_description_global': 'Directly create non-administrator users.',
  'user_invite_permission_description_global': 'Invite users via email.',
  'user_delete_permission_description_global': 'Delete any non-administrator user. Users must be disabled before they can be deleted.',
  'user_enable_disable_permission_description_global': 'Enable or disable any non-administrator user.',
  'user_edit_email_permission_description_global': 'Change the email of any non-administrator user.',
  'user_edit_password_permission_description_global': 'Change the password of any non-administrator user.',
  'user_edit_note_permission_description_global': 'Change the note of any non-administrator user.',
  'user_edit_display_name_permission_description_global': 'Change the display name of any non-administrator user.',
  'user_manage_2fa_permission_description_global': 'Manage login verification for any non-administrator user. Includes enable/disable 2FA enforcement, reset 2FA configuration, disable email login verification.',
  'user_force_logout_permission_description_global': 'Force logout any non-administrator user from all devices.',
  'user_change_group_permission_description_global': 'Change any non-admin user\'s group',
  'user_change_strategy_permission_description_global': 'Change any non-admin user\'s strategy',
  'user_change_control_role_permission_description_global': 'Change any non-admin user\'s control role',

  // User permissions - Group type
  'view_users_permission_description_group_scoped': 'Read list information of users within selected user groups.',
  'user_create_permission_description_group_scoped': 'Create non-administrator users within selected user groups.',
  'user_invite_permission_description_group_scoped': 'Invite users via email within selected user groups.',
  'user_delete_permission_description_group_scoped': 'Delete non-administrator users within selected user groups. Users must be disabled before they can be deleted.',
  'user_enable_disable_permission_description_group_scoped': 'Enable or disable non-administrator users within selected user groups.',
  'user_edit_email_permission_description_group_scoped': 'Change the email of non-administrator users within selected user groups.',
  'user_edit_password_permission_description_group_scoped': 'Change the password of non-administrator users within selected user groups.',
  'user_edit_note_permission_description_group_scoped': 'Change the note of non-administrator users within selected user groups.',
  'user_edit_display_name_permission_description_group_scoped': 'Change the display name of non-administrator users within selected user groups.',
  'user_manage_2fa_permission_description_group_scoped': 'Manage login verification for non-administrator users within selected user groups. Includes enable/disable 2FA enforcement, reset 2FA configuration, disable email login verification.',
  'user_force_logout_permission_description_group_scoped': 'Force logout non-administrator users within selected user groups from all devices.',
  'user_change_strategy_permission_description_group_scoped': 'Change the strategy of non-admin users within selected user groups.',
  'user_change_control_role_permission_description_group_scoped': 'Change the control role of non-admin users within selected user groups.',

  // Device permissions - Global type
  'view_devices_permission_description_global': 'Read list information of all devices.',
  'device_enable_disable_permission_description_global': 'Enable or disable any device.',
  'device_delete_permission_description_global': 'Delete any device. Devices must be disabled before they can be deleted.',
  'device_edit_info_permission_description_global': 'Edit device name, device username (system username of the device, not the RustDesk user), and note for any device.',
  'device_assign_to_user_permission_description_global': 'Assign any device to any user.',
  'device_change_group_permission_description_global': 'Change any device\'s group',
  'device_change_strategy_permission_description_global': 'Change any device\'s strategy',

  // Device permissions - Group type
  'view_devices_permission_description_group_scoped': 'Read list information of devices managed by the current role.',
  'device_enable_disable_permission_description_group_scoped': 'Enable or disable devices managed by the current role.',
  'device_delete_permission_description_group_scoped': 'Delete devices managed by the current role. Devices must be disabled before they can be deleted.',
  'device_edit_info_permission_description_group_scoped': 'Edit device name, device username (system username of the device, not the RustDesk user), and note for devices managed by the current role.',
  'device_change_strategy_permission_description_group_scoped': 'Change strategy of devices managed by the current role.',

  // Device permissions - Individual type
  'view_devices_permission_description_individual': 'Read list information of the user\'s devices.',
  'device_enable_disable_permission_description_individual': 'Enable or disable the user\'s devices.',
  'device_delete_permission_description_individual': 'Delete the user\'s devices. Devices must be disabled before they can be deleted.',
  'device_edit_info_permission_description_individual': 'Edit device name, device username (system username of the device, not the RustDesk user), and note for the user\'s devices.',
  'device_change_strategy_permission_description_individual': 'Change strategy of the user\'s devices.',

  // User Groups permissions - Global type
  'view_user_groups_permission_description_global': 'Read list information of all user groups. If having Users View permission, can view group members. If having Users Update Group permission, can batch update users\' groups here.',
  'edit_user_groups_permission_description_global': 'Create, edit, and delete user groups, does not include updating group members.',

  // Device Groups permissions - Global type
  'view_device_groups_permission_description_global': 'Read list information of all device groups. If having Devices View permission, can view group members. If having Devices Update Group permission, can batch update devices\' groups here.',
  'edit_device_groups_permission_description_global': 'Create, edit, and delete device groups, does not include updating group members. Includes Update Strategy permission.',
  'device_group_change_strategy_permission_description_global': 'Change any device group\'s strategy',

  // Audit Logs permissions - Global type
  'view_audits_permission_description_global': 'Read all logs. Can edit notes. Even when "Only admin can access logs" option is enabled.',
  'edit_audits_permission_description_global': 'Can disconnect any active connection.',

  // Audit Logs permissions - Individual type
  'view_audits_permission_description_individual': 'Read personal logs. For connection logs, personal logs include logs where devices currently assigned to the user are the controlled or controlling device, and logs where the user is the controller. Can edit notes. Even when "Only admin can access logs" option is enabled.',
  'edit_audits_permission_description_individual': 'Can disconnect personal active connections.',

  // Strategies permissions - Global type
  'view_strategies_permission_description_global': 'Read any strategy. If having Users View, Devices View, and Device Groups View permissions, can read strategies for users, devices, and device groups. If having Users Update Strategy, Devices Update Strategy, and Device Groups Update Strategy permissions, can batch update corresponding strategies here.',
  'edit_strategies_permission_description_global': 'Create, edit, and delete strategies, does not include updating strategies for users, devices, and device groups.',

  // Control Roles permissions - Global type
  'view_control_roles_permission_description_global': 'Read any control role. If having Users View permission, can read control roles for users. If having Users Update Control Role permission, can batch update corresponding control roles here.',
  'edit_control_roles_permission_description_global': 'Create, edit, and delete control roles, does not include updating control roles for users.',

  // Custom Clients permissions
  'view_custom_clients_permission_description': 'Read the list of custom clients. Can download compiled custom clients. Cannot read detailed configuration of custom clients.',
  'edit_custom_clients_permission_description': 'Create, edit, and delete custom clients.',

  'global_type_description': 'For managing all users, devices, and other resources across the entire system.',
  'individual_type_description': 'For managing the assigned user\'s own devices and logs.',
  'group_scoped_type_description': 'For managing users within specific user groups, and devices belonging to specific device groups or assigned to those users.',

  'user_groups_scope_description': 'Manage users within selected user groups, and devices assigned to those users.',
  'device_groups_scope_description': 'Manage devices within selected device groups.',
  'unassigned_devices_scope_description': 'Manage unassigned devices (not assigned to any user or device group).',

  'sync_device_name_with_hostname': "Sync device name with computer's hostname",
  'allow_device_name_change_tip': "When enabled, the device name will sync with the computer's hostname. Manual changes (web console, CLI, or API) may be overwritten after the client reboots or the service restarts.",

  'Keyboard/Mouse': 'Keyboard/Mouse',
  'Remote Printer': 'Remote Printer',
  'Clipboard': 'Clipboard',
  'File Transfer': 'File Transfer',
  'Audio': 'Audio',
  'Camera': 'Camera',
  'Terminal': 'Terminal',
  'TCP Tunnel': 'TCP Tunnel',
  'Remote Restart': 'Remote Restart',
  'Recording Session': 'Recording Session',
  'Block User Input': 'Block User Input',
  'Remote Configuration Modification': 'Remote Configuration Modification',
  'Control Role': 'Control Role',
  'Control Roles': 'Control Roles',
  'Admin Roles': 'Admin Roles',
  'Strategy': 'Strategy',
  'create_control_role': 'Create Control Role',
  'update_control_role': 'Update Control Role',
  'delete_control_role': 'Delete Control Role',
  'assign_users_to_control_role': 'Assign Users to Control Role',
  'remove_users_from_control_role': 'Remove Users from Control Role',
  'not_logged_control_role_description': 'Applied when the controlling side is not logged in.',
  'default_control_role_description': 'Applied to users who are not assigned to any specific control role.',
  'control_role_not_set': 'Use Client Settings',
  'control_role_enable': 'Enabled',
  'control_role_disable': 'Disabled',
  'Remove': 'Remove',
  'Admin Role Permission': 'Admin Role Permission',
  'Control Role Permission': 'Control Role Permission',
  'Click to view users': 'Click to view users',
  'Click to assign users': 'Click to assign users',
  'pages.AuditList.AlarmAuditList.Login Device / Controlling Side': 'From',
  'pages.AuditList.AlarmAuditList.Login Account / Controlled Device': 'Target',
  'pages.AuditList.AlarmAuditList.From Tip': 'Account / Login Device / Controlling Side',
  'pages.AuditList.AlarmAuditList.Target Tip': 'Login Account / Controlled Device',
  'pages.AuditList.AlarmAuditList.Controlled Device': 'Controlled Device',
  'pages.AuditList.AlarmAuditList.Login Account Search Tip': 'Login-account alarm logs always support Login Account search. Connection-type alarm logs require controlled client version >= 1.4.9 for controlling Login Account search.',
  'pages.AuditList.AlarmAuditList.TerminalOsLoginBackoff': 'Multiple failed Terminal (Run as administrator) login attempts (wrong username/password)',
  'pages.AuditList.AlarmAuditList.TerminalOsLoginConcurrency': 'Multiple simultaneous Terminal (Run as administrator) login attempts',
  'pages.AuditList.AlarmAuditList.SessionScopeViolation': 'Session scope violation',
  'Assign Users': 'Assign Users',
  'Added successfully': 'Added successfully',
  'Adding failed, please try again!': 'Adding failed, please try again!',
  'Update is successful': 'Update is successful',
  'Update failed, please try again!': 'Update failed, please try again!',
  'Deletion is successful': 'Deletion is successful',
  'Deletion failed, please try again!': 'Deletion failed, please try again!',
  'Allow': 'Allow',
  'Disallow': 'Disallow',
  'Allowed': 'Allowed',
  'Disallowed': 'Disallowed',
  'user groups': 'user groups',
  'users': 'users',
  'other groups': 'other groups',
  'Select a group': 'Select a group',
  'Select a user': 'Select a user',
  'new version available': 'new version available',
  'Config & QR code && Windows EXE': 'Config & QR code && Windows EXE',
  'Server': 'Server',
  'API': 'API',
  'Update': 'Update',
  'Allow connections within group': 'Allow connections within group',
  'Allow connections to other groups': 'Allow connections to other groups',
  'Allow connections from other groups': 'Allow connections from other groups',
  'Allow connections from user groups': 'Allow connections from user groups',
  'Allow connections from users': 'Allow connections from users',
};
